var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReporting = props => /*#__PURE__*/React.createElement("svg", _extends({
  stroke: "#C9C9C9",
  fill: "none",
  strokeWidth: 2,
  viewBox: "0 0 24 24",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  height: "1em",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h5.697"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M18 14v4h4"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M18 11v-4a2 2 0 0 0 -2 -2h-2"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M8 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M18 18m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M8 11h4"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M8 15h3"
})));
export default SvgReporting;